<app-nav></app-nav>
<div class="container">
  <section class="insurances-panel">
    <div class="container px-2">
      <div class="col">
        <ng-container *ngFor="let notification of notificationList">
          <div class="policy-content border rounded px-3 py-2 mb-2" *ngIf="notificationList.length > 0"
            [ngClass]="{'isRead': notification.readByUser}">
            <div class="justify-content-between">
              <p>{{notification.message}}</p>
              <!-- <div class="text-center">
                <img src="{{notification.fileUrl}}" />
              </div> -->
              <span class="date">{{notification.created | date: 'dd-MMM-yyyy'}}</span>
              <span class="read" routerLink="/viewNotification/{{notification._id}}">Read More</span>
              <div class="clearfix"></div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="notificationList.length < 1">
          <p class="text-center mt-4">No notification</p>
        </div>
      </div>
    </div>
    <div id="spinner" [hidden]="!loading">
      <div class="spinnerfull">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
    </div>
  </section>
</div>